import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Stack, Tabs } from '@mantine/core'
import { BaleDetails } from '@/pages/stations/wool-data/bale-details/bale-details.page'
import { CreditorHistory } from '@/pages/stations/wool-data/creditor-history/creditor-history.page'
import { LotDetails } from '@/pages/stations/wool-data/lot-details/lot-details.page'
import { ReceivalHistory } from '@/pages/stations/wool-data/receival-history/receival-history.page'
import { WoolContracts } from '@/pages/stations/wool-data/wool-contracts/wool-contracts.page'
import { useNavigation } from '@/hooks/use-navigation'
import { ClipSummary } from '@/pages/stations/wool-data/clip-summary/clip-summary.page'

export const WoolDataTabValue = {
  CLIP_SUMMARY: 'clip-summary',
  WOOL_CONTRACTS: 'wool-contracts',
  LOT_DATA: 'lot-data',
  BALE_DETAILS: 'bale-details',
  CREDITOR_HISTORY: 'creditor-history',
  RECEIVAL_HISTORY: 'receival-history',
} as const

export function StationWoolDataPage() {
  const { navigateToWoolDataTab } = useNavigation()
  const { stationRecordNumber, woolDataTabValue } = useParams()

  // If root wool data route, redirect to wool contracts panel by default
  useEffect(() => {
    if (stationRecordNumber && woolDataTabValue === undefined) {
      navigateToWoolDataTab(stationRecordNumber, WoolDataTabValue.CLIP_SUMMARY)
    }
  }, [woolDataTabValue])

  return (
    <Stack data-testid='station-wool-data'>
      <Tabs
        variant='pills'
        radius='md'
        value={woolDataTabValue}
        onChange={(value) => {
          navigateToWoolDataTab(stationRecordNumber ?? '', value ?? '')
        }}
        orientation='vertical'
        keepMounted={false}
      >
        <Tabs.List mr='xl'>
          <Tabs.Tab value={WoolDataTabValue.CLIP_SUMMARY}>Clip Summary</Tabs.Tab>
          <Tabs.Tab value={WoolDataTabValue.WOOL_CONTRACTS}>Wool Contracts</Tabs.Tab>
          <Tabs.Tab value={WoolDataTabValue.LOT_DATA}>Lot Data</Tabs.Tab>
          <Tabs.Tab value={WoolDataTabValue.BALE_DETAILS}>Bale Details</Tabs.Tab>
          <Tabs.Tab value={WoolDataTabValue.CREDITOR_HISTORY}>Creditor History</Tabs.Tab>
          <Tabs.Tab value={WoolDataTabValue.RECEIVAL_HISTORY}>Receival History</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value={WoolDataTabValue.CLIP_SUMMARY}>
          <ClipSummary />
        </Tabs.Panel>
        <Tabs.Panel value={WoolDataTabValue.WOOL_CONTRACTS}>
          <WoolContracts />
        </Tabs.Panel>
        <Tabs.Panel value={WoolDataTabValue.LOT_DATA}>
          <LotDetails />
        </Tabs.Panel>
        <Tabs.Panel value={WoolDataTabValue.BALE_DETAILS}>
          <BaleDetails />
        </Tabs.Panel>
        <Tabs.Panel value={WoolDataTabValue.CREDITOR_HISTORY}>
          <CreditorHistory />
        </Tabs.Panel>
        <Tabs.Panel value={WoolDataTabValue.RECEIVAL_HISTORY}>
          <ReceivalHistory />
        </Tabs.Panel>
      </Tabs>
    </Stack>
  )
}
